import Styles from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import i18n from "../../helpers/i18n";
import Logo from "../_UI/logo";
import LangSwitcher from "../_UI/langSwitcher";
import Navigation from "../_UI/navigation";
import CustomBorder from "../_UI/customBorder";
import {buildCrossDomainLink} from "../../utils/buildCrossDomainLink";
import {useNavigate} from "react-router-dom";

const Header = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [mobileMenu, setMobileMenu] = useState(false);

    useEffect(() => {
        const body = document.body;
        const html = document.documentElement;

        const prevBodyOverflow = body.style.overflow;
        const prevHtmlOverflow = html.style.overflow;

        if (mobileMenu) {
            body.style.overflow = 'hidden';
            html.style.overflow = 'hidden';
        } else {
            body.style.overflow = '';
            html.style.overflow = '';
        }

        return () => {
            body.style.overflow = prevBodyOverflow || '';
            html.style.overflow = prevHtmlOverflow || '';
        };
    }, [mobileMenu]);

    return (
        <section className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <a
                    href={buildCrossDomainLink({
                        baseUrl: process.env.REACT_APP_NEXT_URL,
                        path: '/',
                        lang: i18n.language?.startsWith('ru') ? 'ru' : 'en',
                    })}
                    className={Styles.logoWrap}
                >
                    <Logo />
                </a>

                <div className={Styles.dNav}>
                    <Navigation />
                </div>

                <div className={Styles.btnsWrap}>
                    <CustomBorder withHover={true}>
                        <button className={Styles.btn} onClick={()=>{navigate('/sign-in')}}>{t('Присоединиться')}</button>
                    </CustomBorder>

                    <LangSwitcher />
                </div>

                <div
                    className={`${Styles.mobileBtn} ${mobileMenu ? Styles.mobileBtnActive : ''}`}
                    onClick={() => setMobileMenu((prev) => !prev)}
                >
                    <div />
                    <div />
                    <div />
                </div>
            </div>

            <div className={`${Styles.mobileMenu} ${mobileMenu ? Styles.mobileMenuOpen : ''}`}>
                <Navigation isMobile={true} mobileMenu={mobileMenu} />

                <div className={Styles.mobileBtnsWrap}>
                    <CustomBorder withHover={true}>
                        <button className={Styles.btn} onClick={()=>{navigate('/sign-in')}}>{t('Присоединиться')}</button>
                    </CustomBorder>

                    <LangSwitcher />
                </div>
            </div>
        </section>
    );
};

export default Header;

